<template>
    <v-container>
        <!-- Dropdown Selection -->
        <v-select v-model="selection"
                  :items="options"
                  :label="$t('SelectType')"
                  outlined
                  @change="emitData"></v-select>

        <!-- Conditional Rendering based on Dropdown Selection -->
        <v-card v-if="ShowIfText">
            <v-card-title>{{ $t('TextInputs') }}</v-card-title>
            <v-card-subtitle>
                <v-row v-for="(text, index) in textInputs" :key="index">
                    <v-col cols="11">
                        <v-text-field hide-details dense v-model="textInputs[index]" :label="$t('TextInput')" outlined @input="emitData"></v-text-field>
                    </v-col>
                    <v-col>
                        <v-btn v-if="textInputs.length > 1" @click="removeTextInput(index)" icon class="mt-5">
                            <v-icon color="error">mdi-trash-can-outline</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
                <v-btn @click="addTextInput" color="primary">{{$t('AddTextInput')}}</v-btn>
            </v-card-subtitle>
        </v-card>

        <v-card v-if="ShowIfImage">
            <v-card-title>{{ $t('ImageUpload') }}</v-card-title>
            <v-file-input ref="fileInput" @change="handleFileUpload" multiple accept="image/*"
                          outlined
                          dense></v-file-input>
            <!--<input type="file" ref="fileInput" accept="image/*" multiple @change="handleFileUpload">-->
            <v-card-subtitle>
                <v-row>
                    <div class="image-preview" v-for="(image, index) in images" :key="index">
                        <img :src="image.url" style="max-width: 200px; margin: 10px; cursor: pointer;" @click="selectImage(index)">
                        <button type="button" @click="removeImage(index)" class="delete-btn">
                            <span class="mdi mdi-close-circle"></span>
                        </button>
                    </div>
                </v-row>
            </v-card-subtitle>
        </v-card>
    </v-container>
</template>

<script>
    export default {
        props: {
            value: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                selection: this.$t('text'),
                textInputs: [''],
                options: [this.$t('text'), this.$t('image')],
                fileInput: null,
                images: []
            }
        },
        watch: {
            value: {
                handler(newValue) {
                    const [type, ...data] = newValue.split('#')
                    this.selection = type

                    if (type === this.$t('text')) {
                        this.textInputs = data[0] ? data[0].split('$') : ['']
                    } else if (type === this.$t('image')) {
                        this.images = data[0] ? data[0].split('$').map(url => ({ url })) : []
                    }
                },
                immediate: true
            },
            images: {
                handler(newVal) {
                    this.emitData()
                },
                deep: true
            }
        },
        computed: {
            ShowIfText() {
                return this.selection === this.$t('text')
            },
            ShowIfImage() {
                return this.selection === this.$t('image')
            },
        },
        methods: {
            addTextInput() {
                this.textInputs.push('')
                this.emitData()
            },
            removeTextInput(index) {
                if (this.textInputs.length > 1) {
                    this.textInputs.splice(index, 1)
                    this.emitData()
                }
            },
            removeImage(index) {
                this.images.splice(index, 1)
            },
            handleFileUpload(files) {
                if (!files.length) return

                for (let i = 0; i < files.length; i++) {
                    const file = files[i]
                    if (!this.validateImageType(file)) {
                        console.error(`File ${file.name} is not a valid image type.`)
                        continue
                    }
                    const reader = new FileReader()
                    reader.onload = (e) => {
                        this.images.push({ url: e.target.result })
                    }
                    reader.readAsDataURL(file)
                }
            },
            validateImageType(file) {
                const allowedTypes = ['image/jpeg', 'image/png', 'image/gif']
                return allowedTypes.includes(file.type)
            },
            emitData() {
                const type = this.selection
                let data = ''

                if (type === this.$t('text')) {
                    data = this.textInputs.filter(text => text.trim() !== '').join('$')
                } else if (type === this.$t('image')) {
                    data = this.images.map(image => image.url).join('$')
                }
                
                if (data !== undefined) {
                    this.$emit('input', `${type}#${data}`)
                } else {
                    console.error('Data is undefined. EmitData cannot proceed.')
                }
            }
        }
    }
</script>


<style scoped>
    .v-card {
        margin-top: 20px;
    }

    .my-2 {
        margin: 0.5rem 0;
    }
    .image-preview {
        display: inline-grid;
        text-align: center;
        position: relative;
        margin: 10px;
    }

    .image-preview img {
        width: 200px;
        height: 200px;
        cursor: pointer;
    }

    .delete-btn {
        position: absolute;
        top: 10px;
        right: 15px;
    }
</style>
